import React, { useState, useEffect } from "react";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface BarProps extends LinearProgressProps {
  label: string;
}

type Props = {
  time: number;
  onTimeOut: () => void;
  stop?: boolean;
};
let timerId: any;

function CountdownTimer(props: Props) {
  const initialTime = props.time * 60;
  const [timeRemaining, setTimeRemaining] = useState(initialTime);
  const [timeOut, setTimeOut] = useState(false);

  useEffect(() => {
    if (timeRemaining > 0) {
      timerId = setTimeout(() => {
        setTimeRemaining(timeRemaining - 1);
      }, 1000);

      return () => clearTimeout(timerId);
    } else {
      props.onTimeOut();
    }
  }, [timeRemaining]);

  useEffect(() => {
    if (props.stop && timerId) {
      clearTimeout(timerId);
    }
  }, [props.stop]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
  const progress = ((initialTime - timeRemaining) / initialTime) * 100;

  const remainingTime =
    minutes.toString().padStart(2, "0") +
    " " +
    seconds.toString().padStart(2, "0");

  return (
    <div>
      <LinearProgressWithLabel label={remainingTime} value={100 - progress} />
    </div>
  );
}

function LinearProgressWithLabel(props: BarProps & { value: number }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 65 }}>
        <Typography
          variant="body2"
          color="text.secondary"
        >{`${props.label}`}</Typography>
      </Box>
    </Box>
  );
}

export default CountdownTimer;
